<template>
    <div style="background: #eff3f7;padding-top: 70px;" class="parent">
        <div class="page-header md-2018121001-xxw">
            <div class="clearfix container">
                <div class="logo-box pull-left">
                    <a class="logo examlogo" href="javascript:;" style="left: 0;top:16px;
                                  font-weight: bold;font-size: 16px;color: #ffffff">职业技能等级认定</a>
                </div>
                <ul class="nav-xxw pull-left">
                    <li class=""><a class="shouye" href="/">首页</a></li>
                    <li class="active"><a class="examZxks">在线测试</a></li>
                </ul>
                <div class="pull-right">
                    <a href="/" class="form-btn form-btn-blue from-save" id="out_login"
                        style="background-color: #4fc7ff;border-color: #4fc7ff;color: #ffffff;">退出</a>
                </div>
            </div>
        </div>

        <div class="page-body ">
            <div class="ka numberCardModal">
                <div class="modal-header">
                </div>
                <div class="modal-body" id="modal-body">
                    <div class="title">
                        <div class="title_border"></div>
                        <div class="title_content">答题卡</div>
                    </div>

                    <!-- 单选题 -->
                    <div v-for="(item,index) in examSubjectlist" :key="index" class="card-content-list">
                        <div class="card-content">
                            <div v-if="item.queType == '01'" class="card-content-title">单选题(共{{item.SubjectCount}}
                                题，合计{{item.queScoreSum}}分)</div>
                            <div v-if="item.queType == '03'" class="card-content-title">判断题(共{{item.SubjectCount}}
                                题，合计{{item.queScoreSum}}分)</div>

                            <div v-if="item.queType == '02'" class="card-content-title">多选题(共{{item.SubjectCount}}
                                题，合计{{item.queScoreSum}}分)</div>

                            <div v-if="item.queType == '04'" class="card-content-title">填空题(共{{item.SubjectCount}}
                                题，合计{{item.queScoreSum}}分)</div>

                            <div v-if="item.queType == '05'" class="card-content-title">证明题(共{{item.SubjectCount}}
                                题，合计{{item.queScoreSum}}分)</div>

                            <div v-if="item.queType == '06'" class="card-content-title">分析题(共{{item.SubjectCount}}
                                题，合计{{item.queScoreSum}}分)</div>

                            <div v-if="item.queType == '07'" class="card-content-title">解答题(共{{item.SubjectCount}}
                                题，合计{{item.queScoreSum}}分)</div>

                            <div v-if="item.queType == '08'" class="card-content-title">实操题(共{{item.SubjectCount}}
                                题，合计{{item.queScoreSum}}分)</div>
                            <div class="box-list">
                                <div v-for="(item1,index1) in item.examSubjectSonlist" :key="index1"
                                    class="box normal-box"
                                    :style="item1.userAnswer == null || item1.userAnswer == ''? '':'background: #1A8CFE;'">
                                    <a class="iconBox que-btn"
                                        :style="item1.userAnswer == null || item1.userAnswer == ''? 'color: #616a89;':'color: white;'">{{index1+1}}<input
                                            class="queka" type="hidden" value="que1386"></a>
                                </div>
                            </div>
                            <div class="split"></div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <span class="box icon-box s1"></span>
                    <span class="icon-label">未答</span>
                    <span class="box icon-box s2"></span>
                    <span class="icon-label">已答</span>
                </div>
            </div>
            <div class="container paper-body-xxw"
                style="margin-left: 19%;margin-top: 23px;width: 70%;box-shadow: 0 1px 4px 0 rgba(58, 62, 81, 0.10);">
                <div class="md-2018121002-xxw js-parent-box">

                    <div v-for="(item,index) in examSubjectlist" :key="index" class="other-1221box js-single-box">

                        <div v-if="item.queType == '01'" class="other-1221-hd">单选题<span class="s1">（合计
                                {{item.SubjectCount}} 题，合计 {{item.queScoreSum}}分）</span></div>
                        <div v-if="item.queType == '03'" class="other-1221-hd">判断题<span class="s1">（合计
                                {{item.SubjectCount}} 题，合计 {{item.queScoreSum}}分）</span></div>

                        <div v-if="item.queType == '02'" class="other-1221-hd">多选题<span class="s1">（合计
                                {{item.SubjectCount}} 题，合计 {{item.queScoreSum}}分）</span></div>

                        <div v-if="item.queType == '04'" class="other-1221-hd">填空题<span class="s1">（合计
                                {{item.SubjectCount}} 题，合计 {{item.queScoreSum}}分）</span></div>

                        <div v-if="item.queType == '05'" class="other-1221-hd">证明题<span class="s1">（合计
                                {{item.SubjectCount}} 题，合计 {{item.queScoreSum}}分）</span></div>

                        <div v-if="item.queType == '06'" class="other-1221-hd">分析题<span class="s1">（合计
                                {{item.SubjectCount}} 题，合计 {{item.queScoreSum}}分）</span></div>

                        <div v-if="item.queType == '07'" class="other-1221-hd">解答题<span class="s1">（合计
                                {{item.SubjectCount}} 题，合计 {{item.queScoreSum}}分）</span></div>

                        <div v-if="item.queType == '08'" class="other-1221-hd">实操题<span class="s1">（合计
                                {{item.SubjectCount}} 题，合计 {{item.queScoreSum}}分）</span></div>

                        <div class="other-1221-bd">
                            <div v-for="(item1,index1) in item.examSubjectSonlist" :key="index1"
                                class=" padding-100 js-single-select test-paper-list">
                                <div class="hd">
                                    <div class="tit" data-questionsort="">
                                        <i class="xxw107-icon"></i>
                                        <div style="width: 35px;float:left;">{{index1+1}}.</div>
                                        <div v-html="item1.queQuestion" style="width: 90%;display: inline-block">
                                            <!-- <p>穿管敷设的铝芯绝缘导线的线芯最小截面应为（&nbsp; ）m㎡。</p> -->
                                        </div>
                                    </div>
                                </div>
                                <!-- 单选题 -->
                                <el-radio-group v-if="item.queType == '01'" class="bd" v-model="item1.userAnswer"
                                    @change="multipleChoice(item1,index,index1)">
                                    <div v-for="(item2,index2) in item1.queOptions" :key="index2"
                                        class="form-checkbox form-checkbox-info item-listx">
                                        <label>
                                            <el-radio :label="item2.serialNum">
                                                <div style="display: flex;">{{item2.serialNum}}. <div
                                                        v-html="item2.optionContent"></div>
                                                </div>
                                            </el-radio>
                                        </label>
                                    </div>
                                </el-radio-group>
                                <!-- 判断题 -->
                                <el-radio-group @change="judgeChoiceChange(item1,index,index1)"
                                    v-if="item.queType == '03'" class="bd" v-model="item1.userAnswer">
                                    <div class="form-checkbox form-checkbox-info item-listx">
                                        <label>
                                            <el-radio label="对">
                                                <div style="display: flex;">对</div>
                                            </el-radio>
                                        </label>
                                    </div>
                                    <div class="form-checkbox form-checkbox-info item-listx">
                                        <label>
                                            <el-radio label="错">
                                                <div style="display: flex;">错</div>
                                            </el-radio>
                                        </label>
                                    </div>
                                </el-radio-group>
                                <!-- 多选题 -->
                                <el-checkbox-group @change="(val)=> multipleChoiceChange(item1,index,index1,val)"
                                    v-if="item.queType == '02'" class="bd" v-model="item1.userAnswerList">
                                    <div v-for="(item2,index2) in item1.queOptions" :key="index2"
                                        class="form-checkbox form-checkbox-info item-listx">
                                        <label>
                                            <el-checkbox :label="item2.serialNum">
                                                <div style="display: flex;">{{item2.serialNum}}. <div
                                                        v-html="item2.optionContent"></div>
                                                </div>
                                            </el-checkbox>
                                        </label>
                                    </div>
                                </el-checkbox-group>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="nav-wrapper">
                <div class="nav250 nav-status nav-operation">
                    <ul class="menu-items">
                        <li class="menu-item menu-item-time" style="border-bottom: 1px solid #eee;">
                            <div class="item-label">剩余时间</div>
                            <div class="item-data" id="timeDown">{{currentTime}}</div>
                        </li>
                        <li class="menu-item menu-item-process" style="border-bottom: 1px solid #eee;">
                            <div class="item-label">当前进度</div>
                            <div class="item-data" id="jindu"><span id="commitCount">{{currentProgress}}</span>/<span
                                    id="totalCount">{{subjectSumCount}}</span></div>
                            <div class="item-process">
                                <div class="item-process-bar" id="commitProcess"></div>
                            </div>
                        </li>
                        <li class="menu-item menu-item-process" style="border-bottom: 1px solid #eee;">
                            <div class="item-label">考生姓名</div>
                            <div class="item-data" id="userName">{{this.$storage.get("declareUser").userName}}</div>
                        </li>
                    </ul>
                </div>
                <button @click="handInAnExaminationPaper" class="form-btn1 form-btn-blue from-save"
                    style="width: 100%;">交卷</button>
            </div>
        </div>




        <div class="camera_outer" style="width: 120px;height: 150px;position: fixed;top: 11%;right:1%">
            <video id="videoCamera" :width="videoWidth" :height="videoHeight" autoplay
                style="width: 100%; height: 100%;"></video>
            <canvas style="display: none" id="canvasCamera" :width="videoWidth" :height="videoHeight"></canvas>
            <div v-if="imgSrc" class="img_bg_camera">
                <img :src="imgSrc" alt="" class="tx_img" />
            </div>
            <!--  <button @click="getCompetence()">打开摄像头</button>
            <button @click="stopNavigator()">关闭摄像头</button>
            <button @click="setImage()">拍照</button> -->
        </div>
    </div>
</template>

<script>
    let loading = null;
    export default {
        name: 'app',
        compoents: {

        },
        data() {
            return {
                subjectSumCount: 0,
                longTime: 0,
                thatMaterialList: [],
                radio: '',
                currentTime: '',
                examSubjectlist: [],
                endTime: '',
                beginTime: '',
                timer: '',
                timer1: '',
                timer2: '',
                mapList: new Map(),
                currentProgress: 0,
                flag: true,
                twoLongTime: 7200000,
                finallyScore: 0,
                mapList: new Map(),
                testId: 0,

                videoWidth: 300,
                videoHeight: 300,
                imgSrc: "",
                thisCancas: null,
                thisContext: null,
                thisVideo: null,
            }
        },

        //async 
        created() {

            if (this.timer) {
                clearInterval(this.timer);
            }

            // await this.getSysTime();

            this.testId = this.$route.params.testId;

            this.laodExamSubject(this.testId);

        },
        mounted() {
            //是否开启人脸比对服务服务
            if (this.$route.params.compareCourseFace === '1') {
                this.getCompetence(); //人脸比对开启 开启摄像头

                let _this = this;

                _this.$message({
                    showClose: true,
                    message: '即将进行人脸比对，请保持脸部与摄像头平齐',
                    duration: 3000
                });

                //人脸抓拍 刚进来五秒钟之后抓拍一次 也仅仅抓拍这一次
                setTimeout(() => {

                    _this.faceCompare();

                }, 3000)



                //五秒比对检测是否人脸
                setInterval(() => {

                    _this.isThereFace();
                    //console.log("我叼你妈的！！！！！")

                }, 5000)
            }
        },
        beforeDestroy() {
            if (this.timer) {
                clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
            }
        },
        methods: {
            //五秒比对检测是否有人脸
            isThereFace() {

                // 点击，canvas画图
                this.thisContext.drawImage(
                    this.thisVideo,
                    0,
                    0,
                    this.videoWidth,
                    this.videoHeight
                );
                // 获取图片base64链接
                var image = this.thisCancas.toDataURL("image/png");

                let jsonObj = {
                    aac002: this.$storage.get("declareUser").idCard,//身份证号码
                    aac003: this.$storage.get("declareUser").userName,//姓名
                    kjmc: this.$route.params.chapterName,//课件名称  （章节名称）
                    headPath: this.$storage.get("declareUser").headPath,//头像
                    photo: image,//抓拍照片  bas64
                }

                let jsonStr = JSON.stringify(jsonObj);


                let parames = new URLSearchParams();
                parames.append('jsonObject', jsonStr);

                this.$axios.post(this.serverUrl + '/userFaceCompare', parames).then(resp => {



                    if (resp.data.code === '1') {

                        if (loading) {
                            loading.close();
                        }

                    } else {

                        loading = this.$loading({
                            lock: true,
                            text: '未检测到人脸',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });


                    }

                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: '服务器繁忙，稍后重试！',
                        type: 'error'
                    });
                })

            },
            //人脸对比 是否本人
            faceCompare() {
                const loading = this.$loading({
                    lock: true,
                    text: '比对中，请稍后...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                // 点击，canvas画图
                this.thisContext.drawImage(
                    this.thisVideo,
                    0,
                    0,
                    this.videoWidth,
                    this.videoHeight
                );
                // 获取图片base64链接
                var image = this.thisCancas.toDataURL("image/png");

                let jsonObj = {
                    aac002: this.$storage.get("declareUser").idCard,//身份证号码
                    aac003: this.$storage.get("declareUser").userName,//姓名
                    kjmc: this.$route.params.chapterName,//课件名称  （章节名称）
                    photo: image,//抓拍照片  bas64
                }

                let jsonStr = JSON.stringify(jsonObj);

                let parames = new URLSearchParams();
                parames.append('jsonObject', jsonStr);

                this.$axios.post(this.serverUrl + '/userExerciseCompare', parames).then(resp => {

                    loading.close();

                    if (resp.data.code === '1') {

                        //人脸对比成功
                        this.$message({
                            message: '人脸对比成功！请进行答题',
                            type: 'success',
                            offset: 400,
                            duration: 1500
                        });

                    } else {
                        //人脸对比失败
                        this.$alert('人脸对比失败，请重新对比', '人脸对比', {
                            confirmButtonText: '确定',
                            callback: action => {

                                this.$message({
                                    showClose: true,
                                    message: '即将进行人脸比对，请保持脸部与摄像头平齐',
                                    duration: 2000
                                });

                                let _this1 = this;

                                setTimeout(() => {
                                    _this1.faceCompare();
                                }, 2000)
                            }
                        });

                    }

                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: '服务器繁忙，稍后重试！',
                        type: 'error'
                    });
                })

            },
            // 调用权限（打开摄像头功能）
            getCompetence() {
                var _this = this;
                this.thisCancas = document.getElementById("canvasCamera");
                this.thisContext = this.thisCancas.getContext("2d");
                this.thisVideo = document.getElementById("videoCamera");
                // 旧版本浏览器可能根本不支持mediaDevices，我们首先设置一个空对象
                if (navigator.mediaDevices === undefined) {
                    navigator.mediaDevices = {};
                }
                // 一些浏览器实现了部分mediaDevices，我们不能只分配一个对象
                // 使用getUserMedia，因为它会覆盖现有的属性。
                // 这里，如果缺少getUserMedia属性，就添加它。
                if (navigator.mediaDevices.getUserMedia === undefined) {
                    navigator.mediaDevices.getUserMedia = function (constraints) {
                        // 首先获取现存的getUserMedia(如果存在)
                        var getUserMedia =
                            navigator.webkitGetUserMedia ||
                            navigator.mozGetUserMedia ||
                            navigator.getUserMedia;
                        // 有些浏览器不支持，会返回错误信息
                        // 保持接口一致
                        if (!getUserMedia) {
                            return Promise.reject(
                                new Error("getUserMedia is not implemented in this browser")
                            );
                        }
                        // 否则，使用Promise将调用包装到旧的navigator.getUserMedia
                        return new Promise(function (resolve, reject) {
                            getUserMedia.call(navigator, constraints, resolve, reject);
                        });
                    };
                }
                var constraints = {
                    audio: false,
                    video: {
                        width: this.videoWidth,
                        height: this.videoHeight,
                        transform: "scaleX(-1)",
                    },
                };
                navigator.mediaDevices
                    .getUserMedia(constraints)
                    .then(function (stream) {
                        // 旧的浏览器可能没有srcObject
                        if ("srcObject" in _this.thisVideo) {
                            _this.thisVideo.srcObject = stream;
                        } else {
                            // 避免在新的浏览器中使用它，因为它正在被弃用。
                            _this.thisVideo.src = window.URL.createObjectURL(stream);
                        }
                        _this.thisVideo.onloadedmetadata = function (e) {
                            _this.thisVideo.play();
                        };
                    })
                    .catch((err) => {
                    });
            },
            saveExamSchedule() {
                let _this = this;

                this.examSubjectlist.forEach(function (element, index) {

                    element.examSubjectSonlist.forEach(function (element1, idnex1) {

                        if (element1.userAnswer != null && element1.userAnswer != '') {

                            if (element.queType != '01' || element.queType != '03') {

                                //单选判断
                                let userScore = 0;
                                let userAnsState = 2; //1正确 2错误

                                if (element1.userAnswer === element1.queAnswer) {
                                    userScore = element1.queScore;
                                    userAnsState = 1;
                                }

                                // 将本题新定义对象 放入
                                let saveTheTopic = {
                                    queId: element1.queId,
                                    userAnswer: element1.userAnswer,
                                    userScore: userScore,
                                    testId: _this.testId,
                                    userAnsState: userAnsState,
                                    userId: _this.$storage.get("declareUser").id,
                                }

                                _this.mapList.set(element1.queId, saveTheTopic);
                            }

                            if (element1.queType == '02') {
                                //多选题
                                let userScore = 0;
                                let userAnsState = 2; //1正确 2错误

                                let userAnswerArray = element1.userAnswer.split(',');

                                let queAnswerArray = element1.queAnswer.split(',');

                                if (userAnswerArray.length === queAnswerArray.length) {

                                    userAnswerArray = userAnswerArray.sort();
                                    queAnswerArray = queAnswerArray.sort();

                                    if (JSON.stringify(userAnswerArray) == JSON.stringify(queAnswerArray)) {
                                        userAnsState = 1;
                                        userScore = element1.queScore;
                                    }
                                }

                                // 将本题新定义对象 放入
                                let saveTheTopic = {
                                    queId: element1.queId,
                                    userAnswer: element1.userAnswer,
                                    userScore: userScore,
                                    testId: _this.testId,
                                    userAnsState: userAnsState,
                                    userId: _this.$storage.get("declareUser").id,
                                }

                                _this.mapList.set(element1.queId, saveTheTopic);


                            }

                            if (element.queType != '01' && element.queType != '02' && element.queType != '03' && element.queType != '04') {

                                let saveTheTopic = {
                                    queId: element1.queId,
                                    userAnswer: element1.userAnswer,
                                    userScore: null,
                                    testId: _this.testId,
                                    userAnsState: null,
                                    userId: _this.$storage.get("declareUser").id,
                                }
                                _this.mapList.set(element1.queId, saveTheTopic);
                            }
                        }
                    })

                })

                let ArrayList = [];
                this.mapList.forEach(function (element, index) {
                    ArrayList.push(element);
                })


                let userQueJson = JSON.stringify(ArrayList);

                let paramesuserQueJson = new URLSearchParams();
                paramesuserQueJson.append('userQueJson', userQueJson);


                this.$axios.post(this.serverUrl + '/ex/updateUserExam', paramesuserQueJson).then(resp => {

                    if (resp.data.code == 1) {

                        console.log("成功了！！！");

                    }

                }).catch(err => {

                })
            },
            //交卷
            handInAnExaminationPaper() {

                const loading1 = this.$loading({
                    lock: true,
                    text: '交卷中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });


                this.saveExamSchedule();


                this.finallyScore = 0;
                let testPass = 1;
                let resultState = 1;
                this.examSubjectlist.forEach(ele => {
                    ele.examSubjectSonlist.forEach(ele1 => {

                        if (ele1.correctOrMistakeState === 2) {
                            this.finallyScore += ele1.queScore;
                        }
                    })
                })

                if (this.finallyScore < 60) {
                    testPass = 1;
                    resultState = 1
                } else {
                    testPass = 2;
                    resultState = 2;
                }

                let parames = new URLSearchParams();
                parames.append('testId', this.$route.params.testId);
                parames.append('chapterId', this.$route.params.chapterId);
                parames.append('testPass', testPass);
                parames.append('resultState', resultState);
                parames.append('classId', this.$route.params.classId);
                parames.append('userId', this.$storage.get("declareUser").id);

                //修改考试状态
                this.$axios.post(this.serverUrl + '/ex/updateUserExamOnlyUpdateUserState', parames).then(resp => {
                    let that = this;
                    loading1.close();
                    if (this.finallyScore < 60) {
                        //分数小于60 成绩不合格
                        this.$confirm('成绩不合格 是否重做?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'info'
                        }).then(() => {
                            //that.$router.go(0);
                        }).catch(() => {
                            //that.$router.go(0);
                        });
                    } else {
                        this.$message({
                            showClose: false,
                            duration: 2000,
                            message: '成绩合格',
                            type: 'success',
                            offset: 300
                        });

                        setTimeout(() => {
                            window.close();
                        }, 2000)

                        //that.$router.go(0);
                    }
                }).catch(err => {

                })
            },
            //判断选中
            judgeChoiceChange(item, index, index1) {
                let userAnswer = this.examSubjectlist[index].examSubjectSonlist[index1].userAnswer;
                let queAnswer = this.examSubjectlist[index].examSubjectSonlist[index1].queAnswer


                if (userAnswer === queAnswer) {

                    this.examSubjectlist[index].examSubjectSonlist[index1].correctOrMistakeState = 2;

                } else {

                    this.examSubjectlist[index].examSubjectSonlist[index1].correctOrMistakeState = 1;

                }

                if (this.examSubjectlist[index].examSubjectSonlist[index1].state != 2) {

                    this.currentProgress += 1;

                }

                this.examSubjectlist[index].examSubjectSonlist[index1].state = 2

            },
            //多选选中
            multipleChoiceChange(item, index, index1, val) {

                let userAnswer1 = this.examSubjectlist[index].examSubjectSonlist[index1].userAnswer;



                let userAnswer = '';
                val.forEach(function (element, index3) {
                    if (val.length === 1 || index3 === val.length - 1) {
                        userAnswer += element
                    } else {
                        userAnswer += element + ","
                    }

                })
                this.examSubjectlist[index].examSubjectSonlist[index1].userAnswer = userAnswer;


                if (userAnswer === '') {
                    this.currentProgress -= 1;

                    this.examSubjectlist[index].examSubjectSonlist[index1].state = 1;
                } else {

                    if (this.examSubjectlist[index].examSubjectSonlist[index1].state != 2) {
                        this.currentProgress += 1;
                    }


                    this.examSubjectlist[index].examSubjectSonlist[index1].state = 2;
                }


                let queAnswer = this.examSubjectlist[index].examSubjectSonlist[index1].queAnswer.split('#').filter(item => {
                    if (item != '') {
                        return item;
                    }
                }).sort().toString();

                let finallyAnswer = this.examSubjectlist[index].examSubjectSonlist[index1].userAnswer.split(',').sort().toString();

                if (queAnswer === finallyAnswer) {
                    this.examSubjectlist[index].examSubjectSonlist[index1].correctOrMistakeState = 2;
                } else {
                    this.examSubjectlist[index].examSubjectSonlist[index1].correctOrMistakeState = 1;
                }

            },
            // 单选选中
            multipleChoice(item, index, index1) {
                let userAnswer = this.examSubjectlist[index].examSubjectSonlist[index1].userAnswer;
                let queAnswer = this.examSubjectlist[index].examSubjectSonlist[index1].queAnswer
                let queScore = this.examSubjectlist[index].examSubjectSonlist[index1].queScore
                if (userAnswer === queAnswer) {
                    //做对了
                    this.examSubjectlist[index].examSubjectSonlist[index1].correctOrMistakeState = 2;
                } else {
                    //做错了
                    this.examSubjectlist[index].examSubjectSonlist[index1].correctOrMistakeState = 1;
                }

                if (this.examSubjectlist[index].examSubjectSonlist[index1].state != 2) {
                    this.currentProgress += 1;
                }

                this.examSubjectlist[index].examSubjectSonlist[index1].state = 2;

            },
            //距离考试结束
            showtime(beginTime, serverTime) {
                var lefttime = beginTime - serverTime;  //距离结束时间的毫秒数
                var leftd = Math.floor(lefttime / (1000 * 60 * 60 * 24));  //计算天数
                var lefth = Math.floor(lefttime / (1000 * 60 * 60) % 24);  //计算小时数
                var leftm = Math.floor(lefttime / (1000 * 60) % 60);  //计算分钟数
                var lefts = Math.floor(lefttime / 1000 % 60);  //计算秒数

                if (lefttime <= 1000) {
                    return "0:0:0"  //返回倒计时的字符串
                } else {
                    return lefth + ":" + leftm + ":" + lefts;  //返回倒计时的字符串
                }
            },
            //获取服务器时间
            /*  getSysTime() {
                 return new Promise((resolve, reject) => {
                     this.$axios.post(this.serverUrl + '/serverTime/getServerTime').then(resp => {
                         this.longTime = resp.data.serverTime;
                         resolve();
                     }).catch(err => {
                     })
                 });
             }, */
            laodExamSubject(testId) {
                let subjectSumCount = 0;

                let parames = new URLSearchParams();
                parames.append('id', testId);

                let ArrayList = [];
                this.$axios.post(this.serverUrl + '/ex/selectOneChipterUserTestAll', parames).then(resp => {
                    let endLongTime = new Date(resp.data.data.endTime).getTime();

                    let _this = this;
                    this.timer = setInterval(() => {
                        let currentTimeStr = _this.showtime(_this.twoLongTime, 0)
                        if (currentTimeStr != '0:0:0') {
                            _this.currentTime = currentTimeStr;
                            _this.twoLongTime -= 1000;
                        } else {
                            if (_this.flag) {
                                _this.flag = false;
                                //考试结束
                                this.$message({
                                    showClose: false,
                                    duration: 3000,
                                    message: '考试时间到，考试即将关闭！',
                                    type: 'warning',
                                    offset: 300
                                });
                                _this.handInAnExaminationPaper(); //交卷
                            }
                        }
                    }, 1000)
                    resp.data.data.exercisesAndQueTypes.forEach(function (element, index) {
                        //试题                  
                        let exam = {
                            queType: '', //试题类型
                            typeName: '', //试题类型名称
                            queScoreSum: 0, //试题类型分数总数
                            SubjectCount: 0, //该类型试题数量
                            examSubjectSonlist: []
                        }

                        let questionTypeList = element;

                        exam.queType = questionTypeList.queType;
                        exam.typeName = questionTypeList.typeName;


                        exam.examSubjectSonlist = questionTypeList.exercisesUserQuestionVos;
                        let queScore = 0;
                        let count = 0;
                        questionTypeList.exercisesUserQuestionVos.forEach(function (element1, index1) {

                            if (element1.userAnswer != null && element1.userAnswer != undefined && element1.userAnswer != '') {
                                element1.state = 2;
                            } else {
                                element1.state = 1;
                            }

                            count += 1;
                            let enterParameterMultipleChoiceQuestion = element1;

                            queScore += element1.queScore

                            subjectSumCount += 1;
                            let userAnswerList = [];

                            //如果是多选题  则创建数组 用户页面回显用
                            if (element.queType == '02') {
                                if (element1.userAnswer != null && element1.userAnswer != '') {
                                    userAnswerList = element1.userAnswer.split(",");
                                }
                            }

                            element1.userAnswerList = userAnswerList;

                            if (element1.userAnswer != null && element1.userAnswer != '') {

                                _this.currentProgress += 1;

                            }


                            //题正确与否标识
                            element1.correctOrMistakeState = 1;


                        })

                        exam.queScoreSum = queScore;
                        exam.SubjectCount = count;

                        ArrayList.push(exam);
                    });
                    this.examSubjectlist = ArrayList;

                    this.subjectSumCount = subjectSumCount;

                }).catch(err => {

                })


            }
        }
    }
</script>

<style scoped>
    .el-checkbox__inner {
        display: inline-block;
        position: relative;
        border: 1px solid #DCDFE6;
        border-radius: 2px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 14px;
        height: 14px;
        background-color: #FFF;
        /* z-index: 1; */
        -webkit-transition: border-color .25s cubic-bezier(.71, -.46, .29, 1.46), background-color .25s cubic-bezier(.71, -.46, .29, 1.46);
        transition: border-color .25s cubic-bezier(.71, -.46, .29, 1.46), background-color .25s cubic-bezier(.71, -.46, .29, 1.46);
    }

    .nav-status .menu-item-process .item-data {
        line-height: 17px;
        margin-bottom: 7px;
    }

    .nav-status .menu-item-process .item-label {
        margin-bottom: 11px;
    }

    .nav-status .menu-item-time .item-data,
    .nav-status .menu-item-exam .item-data {
        font-size: 18px;
        line-height: 22px;
        color: #FF0000;
        font-weight: 400;
    }

    .nav-status .menu-item-time .item-label,
    .nav-status .menu-item-exam .item-label {
        margin-bottom: 3px;
    }

    .nav-wrapper .nav250.nav-operation .menu-item {
        padding: 14px 0;
    }

    .form-btn-blue {
        color: #fff;
        background-color: #4b95ff;
        border-color: #4b95ff;
    }

    .nav-wrapper .nav250 {
        color: #27274A;
        line-height: 20px;
        padding: 0 10px;
        background: #FFFFFF;
        box-shadow: 0 1px 4px 0 rgb(0 0 0 / 10%);
        border-radius: 4px;
        margin-bottom: 10px;
        text-align: center;
        list-style: none;
    }


    .nav-wrapper {
        right: 23px;
        bottom: 20px;
        position: fixed;
        top: 270px;
        width: 7%;
    }

    .el-collapse {
        border: 1px solid #EBEEF5;

        padding: 10px;
    }

    .ql-toolbar.ql-snow+.ql-container.ql-snow {
        border-top: 0px;
        height: 150px;
    }

    .layui-btn {
        display: inline-block;
        height: 38px;
        line-height: 38px;
        padding: 0 18px;
        background-color: #009688;
        color: #fff;
        white-space: nowrap;
        text-align: center;
        font-size: 14px;
        border: none;
        border-radius: 2px;
        cursor: pointer;
    }

    .layui-btn-xs {
        height: 22px;
        line-height: 22px;
        padding: 0 5px;
        font-size: 12px;
    }

    .form-checkbox label>input[type="radio"]+p::after {
        display: inline-block;
        position: absolute;
        content: " ";
        width: 8px;
        height: 8px;
        left: 4px;
        top: 7px;
        margin-left: -20px;
        border-radius: 50%;
        background-color: #555555;
        -webkit-transform: scale(0, 0);
        -ms-transform: scale(0, 0);
        -o-transform: scale(0, 0);
        transform: scale(0, 0);
    }

    .form-checkbox label>input[type="radio"]+p::before {
        content: "";
        display: inline-block;
        position: absolute;
        width: 14px;
        height: 14px;
        left: 0;
        top: 3px;
        margin-left: -20px;
        border: 1px solid #cccccc;
        border-radius: 50%;
        background-color: #fff;
    }

    .form-checkbox>label {
        padding-left: 20px;
        position: relative;
    }

    .md-2018121002-xxw .item-listx label {
        display: flex;
        padding: 10px 15px;
        border: 1px solid transparent;
    }

    .md-2018121001-xxw {
        background: #049be2;
        height: 70px;
        line-height: 68px;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 1;
    }

    .xxw107-icon {
        display: inline-block;
        padding: 8px;
        position: relative;
        top: 2px;
        left: -10px;
        display: none;
    }

    .md-2018121002-xxw .hd>.tit {
        display: block;
        align-items: baseline;
    }

    .md-2018121002-xxw .hd {
        margin-bottom: 20px;
        color: #333;
        font-weight: bold;
    }

    .padding-100 {
        padding: 70px 100px 20px;
    }

    .md-2018121002-xxw .padding-100 {
        padding-bottom: 0;
        padding-top: 0;
    }

    .md-2018121002-xxw .test-paper-list {
        margin-bottom: 24px;
    }

    .other-1221-hd .s1 {
        font-size: 16px;
    }

    .other-1221-hd {
        padding: 0 22px;
        line-height: 42px;
        background: #d4f0fd;
        color: #014c85;
        font-size: 22px;
        width: 95%;
        margin: 0 auto;
        margin-bottom: 36px;
    }

    .paper-body-xxw {
        background: #fff;
        margin-bottom: 60px;
        padding-bottom: 40px;
        position: relative;
        padding-top: 50px;
        margin-left: 265px;
    }

    .s2 {
        background: #1A8CFE;
    }

    .icon-label {
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #656577;
    }

    .icon-box.s1 {
        background: #F1F3F8;
    }

    .modal-footer {
        padding: 10px 20px 10px 0px;
        background-color: #fff;
        border: unset;
        box-shadow: 0 -2px 10px 0 rgb(58 62 81 / 10%);
        text-align: right;
    }

    .iconBox {
        line-height: 32px;
        font-size: 14px;
        display: inline-block;
        width: 100%;
        height: 0%;
        color: #616a89;
        border-radius: 2px 2px 0 0;
    }

    .box {
        height: 32px;
        width: 32px;
        line-height: 18px;
        padding-bottom: 0;
        font-size: 0;
        display: inline-block;
        text-align: center;
        background: #F1F3F8;
        line-height: 12px;
        position: relative;
        margin: 0 3px 6px;
        border-radius: 2px 2px 0 0;
        overflow: hidden;
    }

    .s2 {
        background: #1A8CFE;
    }

    .icon-box {
        width: 10px;
        height: 10px;
        display: inline-block;
        margin: 0 3px 0px;
        padding-bottom: 0px;
    }

    .box-list .s1 {
        background: #F1F3F8;
    }

    .box-list {
        position: relative;
        left: -5px;
        font-size: 0;
        margin-right: -15px;
    }

    .card-content-title {
        font-size: 14px;
        color: #27274A;
        font-weight: 600;
        padding-bottom: 12px;
        padding-top: 20px;
    }

    .card-content {
        padding: 0 20px 0 20px;
        position: relative;
    }

    .card-content-list {
        font-size: 12px;
        color: #27274A;
        font-weight: 600;
    }

    .title_content {
        margin-left: 14px;
        font-weight: 600;
        color: #27274A;
    }

    .title_border {
        display: inline-block;
        width: 4px;
        height: 18px;
        background: #1A8CFE;
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
    }

    .title {
        position: relative;
        text-align: left;
        margin-left: 20px;
        margin-bottom: 0;
        font-size: 18px;
        padding-bottom: 0px;
        color: #666666;
        letter-spacing: 0;
    }

    .modal-body {
        overflow-y: auto;
        height: 494px;
        padding-bottom: 36px;
    }

    .modal-header {
        padding: 10px;
        /* height: 20px; */
        border: none;
    }

    .ka {
        width: 15%;
        height: 550px;
        left: 37px;
        float: left;
        position: fixed;
        top: 93px;
        background-color: white;
        z-index: 999;
        box-shadow: 0 1px 4px 0 rgb(58 62 81 / 10%);
    }

    .parent {
        font-family: Microsoft YaHei, Helvetica Neue, Helvetica, STHeiTi, Arial, sans-serif;
        font-size: 16px;
        line-height: 1.4;
    }

    .md-2018121001-xxw .nav-xxw li a {
        display: block;
        color: inherit;
    }

    .md-2018121001-xxw .nav-xxw .active {
        color: #ffcc33;
        font-weight: bold;
    }

    .form-btn1 {
        display: inline-block;
        padding: 5px 0px 6px;
        margin-bottom: 0;
        font-size: 14px;
        font-weight: normal;
        line-height: 1.42857143;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        -ms-touch-action: manipulation;
        touch-action: manipulation;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background-image: none;
        border: 1px solid transparent;
        border-radius: 4px;
        /* height: 32px; */
    }

    .form-btn {
        display: inline-block;
        padding: 5px 20px 6px;
        margin-bottom: 0;
        font-size: 14px;
        font-weight: normal;
        line-height: 1.42857143;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        -ms-touch-action: manipulation;
        touch-action: manipulation;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background-image: none;
        border: 1px solid transparent;
        border-radius: 4px;
        /* height: 32px; */
    }

    .ks-btn {
        display: inline-block;
        line-height: 26px;
        background: #29b2f7;
        color: #fff;
        padding: 2px 8px;
        border-radius: 4px;
        cursor: pointer;
    }

    .layui-bg-gray {
        background-color: #eee !important;
        color: #666 !important;
    }

    .layui-badge {
        height: 18px;
        line-height: 18px;
        position: relative;
        display: inline-block;
        padding: 0 6px;
        font-size: 12px;
        text-align: center;
        color: #fff;
        border-radius: 2px;
    }

    .ks-typex {
        display: inline-block;
        line-height: 26px;
        background: #ec7064;
        color: #fff;
        padding: 0 16px;
        border-radius: 15px;
    }

    .layui-icon-search:before {
        content: "\e615";
    }

    .layui-icon {
        font-family: layui-icon !important;
        font-size: 16px;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .md-2018121102-xxw .form-group span {
        width: 48px;
        height: 50px;
        font-size: 24px;
        background: #bdc3c7;
        text-align: center;
        line-height: 46px;
        color: #fff;
        cursor: pointer;
    }

    .md-2018121102-xxw .form-group input {
        width: 750px;
        height: 100%;
        padding-left: 10px;
        background: #fdfdfd;
        border: none;
    }

    .md-2018121102-xxw .form-group {
        width: 800px;
        height: 48px;
        border-radius: 4px;
        border: 1px solid #bdc3c7;
        overflow: hidden;
    }

    .md-2018121102-xxw>.md-bd {
        padding: 30px 40px;
    }

    .color-28b2f7 {
        color: #28b2f7;
    }

    .bg-fff {
        background: #fff;
    }

    .padding-40px {
        padding: 0 40px;
    }

    .md-2018121102-xxw .md-hd {
        line-height: 50px;
        margin: 28px 0;
        border-radius: 8px;
        font-size: 16px;
        font-weight: bold;
    }

    .aaaaa {
        background: #f3f2f2;
        line-height: 24px;
        font: 14px Helvetica Neue, Helvetica, PingFang SC, Tahoma, Arial, sans-serif;
    }

    .md-2018121001-xxw .nav-xxw li {
        float: left;
        margin-right: 35px;
    }

    .md-2018121001-xxw .nav-xxw .active {
        color: #ffcc33;
        font-weight: bold;
    }

    .md-2018121001-xxw .nav-xxw {
        color: #ffffff;
        margin-left: 68px;
        font-size: 16px;
    }

    a {
        color: #333;
        text-decoration: none;
    }

    .container {
        clear: both;
        margin: 0 auto;
        text-align: left;
        width: 1200px;
    }

    .pull-left {
        float: left;
    }

    .pull-right {
        float: right;
    }
</style>


// WEBPACK FOOTER //
// src/components/train/chapterTest.vue